
import { styled } from "@mui/system";
import Grid from "@mui/material/Grid";

const ConditionalBorderGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    borderRight: "1px solid #ccc",
    paddingRight: theme.spacing(2),
  },
}));

export default ConditionalBorderGrid;